import { ICompatibilityResult } from './compatibility-result';
import { ISingleEpletMmRisk } from '@nkr/models/index';
import { ILkdpiInfo } from '@nkr/models/index';

export interface ICompatibilityResultsResponse {
    data: {
        success: boolean;
        results: {
            compatibilityResults: ICompatibilityResult[],
            donorMatchData: {
                totalHlaPoints: number,
                singleEpletMmRisk: ISingleEpletMmRisk,
                avoids: any[],
                compatibilityResult: ICompatibilityResult,
                lkdpiInfo: ILkdpiInfo
            }
        };
    }
}
